import React, { useState, useEffect } from "react";
import { Table, Input, Checkbox, Button, Form, message, Popconfirm, Drawer, Row, Col } from "antd";
import { metaDataGroupManage } from '../../../services/admin/adminService';
import Grid from "../components/CommonFields/Grid";
import '../assets/styles/common.css';

const LoadDataGroup = ({ onSave }) => {
    const [loading, setLoading] = useState(false);
    const [dataGroupList, setDataGroupList] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const dataGroupColumns = [
        { title: 'Group Id', dataIndex: 'groupId', key: 'groupId', hidden: true },
        { title: 'Group Name', dataIndex: 'GroupName', key: 'GroupName' },
    ]

    useEffect(() => {
        const fetchDataGroupList = async () => {
            setLoading(true);
            try {
                const payload = {
                    groupId: 0,
                    groupName: "",
                    groupType: "",
                    actionType: "get",
                    fieldConfigData: null,
                    groupDesc: ""
                };
                const response = await metaDataGroupManage(payload);
                if (response?.success) {
                    setDataGroupList(response.data?.group);
                }
            } catch (error) {
                message.error("Failed to load data groups");
            } finally {
                setLoading(false);
            }
        };
        fetchDataGroupList();
    }, []);


    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
    };

    const handleRowSelection = (selectedKeys, selectedRows) => {
        console.log("ww:", selectedKeys);
        setSelectedRowKeys(selectedKeys);
    };

    return (
        <>
            {/* <Table
                rowSelection={rowSelection}
                columns={dataGroupColumns.filter(col => !col.hidden)} // Exclude hidden columns            
                rowKey="groupId"
                dataSource={dataGroupList}
                loading={loading}
                pagination={true}
                bordered
            ></Table> */}

            <Grid
                columnData={{ columns: dataGroupColumns }}
                tableData={dataGroupList}
                rowKey="groupId"
                searchButton={false}
                downloadCSV={false}
                showEdit={false}
                showDelete={false}
                showView={false}
                showPagination={true}
                // csvFileName="StepData"
                // paginationConfig={{ pageSizeOptions: ['10', '20', '50', '100'] }}
                //className="custom-grid"
                createButton={false}
                enableRowSelection={true}
                onRowSelectionChange={handleRowSelection}
                locale={{ emptyText: 'No data found' }}
            />

            <div>
                <Button type="primary" onClick={() => onSave(selectedRowKeys)}>
                    Save
                </Button>
            </div>
        </>
    );
}

export default LoadDataGroup;